$("#loginForm").validate();
const passwordField = $("#password");
$("#show_password").on("click", function () {
    $("#hide_password").toggleClass("d-none");
    $("#show_password").toggleClass("d-none");
    passwordField.attr("type", "text");
});

$("#hide_password").on("click", function () {
    $("#show_password").toggleClass("d-none");
    $("#hide_password").toggleClass("d-none");
    passwordField.attr("type", "password");
});
